var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ur-tab__navi"},[(_vm.tabBox.addBtn)?_c('div',{staticClass:"ur-tab__navi__item ur-tab__navi__item--add",on:{"click":_vm.clickAdd}},[_c('ur-icon',{attrs:{"iconType":"picto"}},[_vm._v("add")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }